import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const base = () => `${config().catalogueServiceBaseUrl}/back-office/render-experiments`;

async function request(path, options = {}) {
    const res = await fetchWithAuth(`${base()}${path}`, options);
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || res.statusText);
    }
    return res.json();
}

const json = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

export const renderExperimentsApi = {
    defaults: () => request('/defaults'),
    eligibleSources: (count, filter = {}) => request('/eligible-sources', json('POST', { count, filter })),
    list: () => request('/'),
    get: (id) => request(`/${id}`),
    create: (input) => request('/', json('POST', input)),
    update: (id, input) => request(`/${id}`, json('PUT', input)),
    remove: (id) => request(`/${id}`, { method: 'DELETE' }),
    start: (id) => request(`/${id}/start`, { method: 'POST' }),
    progress: (id) => request(`/${id}/progress`),
    next: (id, rater, exclude = []) => {
        const params = new URLSearchParams({ rater });
        if (exclude.length) params.set('exclude', exclude.join(','));
        return request(`/${id}/rate?${params}`);
    },
    vote: (id, body) => request(`/${id}/votes`, json('POST', body)),
    results: (id) => request(`/${id}/results`),
};
